import React, { useState, useEffect } from "react";
import "react-day-picker/dist/style.css";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import { useAlert } from "../contexts/AlertContext";
import { useAtom } from "jotai";
import { authAtom } from "../states/auth";
import Offcanvas from "react-bootstrap/Offcanvas";
import Collapse from "react-bootstrap/Collapse";
import Modal from "react-bootstrap/Modal";
import { CubeIcon, EditIcon } from "../components/SVGIcon";
import { UsersFillIcon } from "../components/Sidebar/SidebarIcons";
import { getExpertScheduleUsers } from "../services/userService";
import { getExpertiseByAdmin } from "../services/expertiseService";
import Form from "react-bootstrap/Form";
import {
  createInternalCallRequest,
  createSupportCallRequest,
} from "../services/supportService";
import ImagePreviewLightbox from "../components/ImagePreviewLightbox";
import Spinner from "react-bootstrap/Spinner";
import { getCompanyStatus } from "./CompanyStatus";
import moment from "moment";

function formatTime(date) {
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

function convertToLocal(utcTime) {
  if (utcTime) {
    const [h, m, s] = utcTime?.split(":");
    const utcDate = new Date(Date.UTC(1970, 0, 1, h, m, s));
    return formatTime(
      new Date(
        utcDate.toLocaleString("en-US", {
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }),
      ),
    );
  }
}

const getAddress = (userInfo) => {
  const addressArr = [];
  if (userInfo?.address) {
    addressArr.push(userInfo?.address);
  }
  if (userInfo?.city) {
    addressArr.push(userInfo?.city);
  }
  if (userInfo?.state?.name) {
    addressArr.push(userInfo?.state?.name);
  }
  if (userInfo?.country?.code) {
    addressArr.push(userInfo?.country?.code);
  }
  if (userInfo?.zipCode) {
    addressArr.push(userInfo?.zipCode);
  }
  return addressArr.join(", ");
};

const ScheduleSidebar = ({
  NewSchedulePanel,
  setNewSchedulePanel,
  getCalenderList,
}) => {
  const [loading, setLoading] = useState(false);
  // const [NewSchedulePanel, setNewSchedulePanel] = useState(false);
  const [createGroup, setCreateGroup] = useState(false);
  const [createCompany, setCreateCompany] = useState(false);
  const [showCompany, setShowCompany] = useState(null);
  const [tab, setTab] = useState(1);
  const [companyExpertise, setCompanyExpertise] = useState(null);
  const [callRequest, setCallRequest] = useState({
    adminId: null,
    expertiseId: null,
    userId: null,
    startTime: null,
    endTime: null,
  });
  const [companyDetailsCollapse, setCompanyDetailsCollapse] = useState(false);
  const [productCollapse, setProductCollapse] = useState({});
  const { showAlert } = useAlert();
  // const [modalShow, setModalShow] = useState(false);
  const [requestDate, setRequestDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [supportList, setSupportList] = useState(false);
  const [filter, setFilter] = useState({
    no_of_result: 20,
    page: 1,
    search: "",
    userTypeFilter: 0,
  });

  const [companyExpertiseFilter, setCompanyExpertiseFilter] = useState({
    no_of_result: 20,
    page: 1,
    search: "",
  });
  const [timeOptions, setTimeOptions] = useState([]);

  const validateSchedule = () => {
    const errors = {};

    if (!requestDate) errors.requestDate = "Request date is required";
    if (!startTime) errors.startTime = "Start time is required";
    if (!endTime) errors.endTime = "End time is required";

    if (requestDate && startTime && endTime) {
      const start = moment(`${requestDate} ${startTime}`, "YYYY-MM-DD HH:mm");
      const end = moment(`${requestDate} ${endTime}`, "YYYY-MM-DD HH:mm");
      const now = moment();

      if (end.isSameOrBefore(start)) {
        errors.endTime = "End time must be after start time";
      }

      if (start.isBefore(now.add(14, "minutes"))) {
        errors.startTime = "Start time must be at least 15 minutes from now";
      }

      const duration = moment.duration(end.diff(start)).asMinutes();
      if (duration < 15) {
        errors.endTime = "Minimum duration is 15 minutes";
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const resetSidebar = () => {
    setTab(1);
    setShowCompany(null);
    setNewSchedulePanel(false);
    setCallRequest({
      adminId: null,
      expertiseId: null,
      userId: null,
      startTime: null,
      endTime: null,
    });
    setRequestDate(null);
    setStartTime(null);
    setEndTime(null);
    setTimeOptions([]);
  };
  const groupByFirstCharacter = (userList) => {
    if (!userList) return {};
console.log("userList", userList);
    // 1. Sort the array alphabetically by fullName (Case Insensitive)
    const sortedList = [...userList].sort((a, b) =>
      a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase()),
    );

    // 2. Reduce the sorted list into groups
    return sortedList.reduce((acc, user) => {
      const firstChar = user.fullName.charAt(0).toUpperCase();
      if (!acc[firstChar]) {
        acc[firstChar] = [];
      }
      acc[firstChar].push(user);
      return acc;
    }, {});
  };

  const createCall = async () => {
    if (!validateSchedule()) return;
    console.log("asdasd", callRequest);
    setLoading(true);

    try {
      let data;
      if (
        callRequest.userId != null &&
        callRequest.expertiseId == null &&
        callRequest.admin == null
      ) {
        data = await createInternalCallRequest(callRequest);
      } else {
        data = await createSupportCallRequest(callRequest);
      }
      console.log("data", data);
      // setModalShow(true);
      getCalenderList();
      resetSidebar();
      setRequestDate(null);
      setStartTime(null);
      setEndTime(null);
      setTimeOptions([]);
    } catch (error) {
      console.error("Error fetching calender:", error);
      showAlert({
        title: "Calender Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    } finally {
      setLoading(false);
    }
  };

  const createCallRequest = (id, isSupportRequest) => {
    console.log("createCallRequest", id, isSupportRequest);
    if (!isSupportRequest) {
      // setTab(3);
      console.log({
        ...callRequest,
        userId: id,
        adminId: null,
        expertiseId: null,
      });
      setCallRequest({
        ...callRequest,
        userId: id,
        adminId: null,
        expertiseId: null,
      });
    } else {
      // setTab(3);
      console.log({
        ...callRequest,
        adminId: showCompany?.id,
        expertiseId: id,
        userId: null,
      });
      setCallRequest({
        ...callRequest,
        adminId: showCompany?.id,
        expertiseId: id,
        userId: null,
      });
    }
  };

  const changeFilterCriteriaByName = (name, value) => {
    // console.log(name, value);
    // filter[name] = value;
    setSupportList(null);
    // setFilter({ ...filter });
    setFilter((prev) => ({ ...prev, [name]: value }));
  };

  const changeCompanyFilterCriteriaByName = (name, value) => {
    // console.log(name, value);
    // companyExpertiseFilter[name] = value;
    setCompanyExpertise(null);
    setCompanyExpertiseFilter((prev) => ({ ...prev, [name]: value }));

    // setCompanyExpertiseFilter({ ...companyExpertiseFilter });
  };

  const getCompanyDetails = async (company) => {
    try {
      const data = await getExpertiseByAdmin(
        company.id,
        companyExpertiseFilter,
      );
      // console.log("asdasdasd",data?.data)

      console.log("selectedCompany", company);
      // setCompanyExpertise(data);
      setShowCompany(company);
      setTab(2);
      const temp = data?.data?.map((element) => {
        return { ...element, fullName: element.name };
      });
      const grouped = groupByFirstCharacter(temp);
      setCompanyExpertise(grouped);
    } catch (error) {
      console.error("Error fetching support users and company:", error);
      showAlert({
        title: "Calender Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };

  const getSupportList = async () => {
    try {
      const data = await getExpertScheduleUsers(filter);
      // console.log("asdasdasd",data?.data)
      const temp = data?.data?.map((element) => {
        return {
          ...element,
          fullName:
            element?.roleId === 2
              ? element?.companyName
              : element.firstName + " " + element.lastName,
        };
      });
      // console.log("aaaassss",temp)
      // setSupportList(data?.data);
      const grouped = groupByFirstCharacter(temp);
      setSupportList(grouped);
    } catch (error) {
      console.error("Error fetching support users and company:", error);
      showAlert({
        title: "Calender Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };

  useEffect(() => {}, [startTime]);

  useEffect(() => {
    getSupportList();
  }, [filter]);

  useEffect(() => {
    if (showCompany) {
      getCompanyDetails(showCompany);
    }
  }, [companyExpertiseFilter]);

  const toggleCollapse = (id) => {
    setProductCollapse((prev) => ({
      ...prev,
      [id]: !prev[id], // toggle only the clicked item
    }));
  };

  useEffect(() => {
    if (!requestDate) return;

    const generateTimeOptions = () => {
      const times = [];
      const now = moment();
      const selectedDate = moment(requestDate, "YYYY-MM-DD");
      const isToday = selectedDate.isSame(now, "day");

      // Start from 00:00 of selected date
      let cursor = moment(requestDate).startOf("day");
      const endOfDay = moment(requestDate).endOf("day");

      while (cursor.isBefore(endOfDay)) {
        // If today, only show times in the future (with 15 min buffer)
        if (!isToday || cursor.isAfter(moment().add(15, "minutes"))) {
          times.push({
            value: cursor.format("HH:mm"), // "14:30"
            label: cursor.format("h:mm A"), // "2:30 PM"
          });
        }
        cursor.add(15, "minutes");
      }
      return times;
    };

    setTimeOptions(generateTimeOptions());
  }, [requestDate]);

  useEffect(() => {
    if (requestDate && startTime && endTime) {
      const startDateTime = moment(
        `${requestDate} ${startTime}`,
        "YYYY-MM-DD HH:mm",
      );
      const endDateTime = moment(
        `${requestDate} ${endTime}`,
        "YYYY-MM-DD HH:mm",
      );

      if (endDateTime.isSameOrBefore(startDateTime)) {
        setEndTime("");
        setCallRequest((prev) => ({ ...prev, endTime: null }));
        return;
      }

      setCallRequest((prev) => ({
        ...prev,
        startTime: startDateTime.toISOString(),
        endTime: endDateTime.toISOString(),
      }));
    }
  }, [requestDate, startTime, endTime]);

  return (
    <>
      <Offcanvas
        show={NewSchedulePanel}
        onHide={() => {
          resetSidebar();
        }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="fs-20 fw-semibold text-gray-700">
            Schedule Video Call
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {tab == 2 && (
            <>
              <div className="company-details-collapse">
                <Button
                  variant=""
                  className="company-details-collapse-btn w-100 d-flex align-items-center justify-content-between gap-4"
                  onClick={() =>
                    setCompanyDetailsCollapse(!companyDetailsCollapse)
                  }
                  aria-controls="company-details-collapse"
                  aria-expanded={companyDetailsCollapse}
                >
                  <div className="d-flex align-items-center gap-3">
                    <Image
                      src={
                        showCompany?.profilePic || "/images/company-icon.svg"
                      }
                      width={56}
                      height={56}
                      alt="Company Icon"
                      className="rounded-circle"
                      style={{
                        objectFit: "cover",
                        width: "56px",
                        height: "56px",
                      }}
                    />

                    <div className="d-flex flex-column align-items-start gap-1">
                      <p className="fs-16 fw-semibold text-gray-700 mb-0">
                        {showCompany?.fullName}
                      </p>
                      <ul className="d-flex align-items-center gap-2 list-unstyled mb-0">
                        <li
                          className={`fs-14 fw-medium ${getCompanyStatus(showCompany?.companyHours).status === "Closed" ? "text-red-500" : "text-blue-600"}`}
                        >
                          {getCompanyStatus(showCompany?.companyHours).status}
                        </li>
                        <li className="dot-separator"></li>
                        <li className="fs-14 fw-normal text-gray-500">
                          {getCompanyStatus(showCompany?.companyHours).time}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <Image
                    className="company-details-collapse-btn-arrow"
                    src="/images/caret-down-rounded-gray.svg"
                    width={32}
                    height={32}
                    alt="Company Icon"
                  />
                </Button>
                <Collapse in={companyDetailsCollapse}>
                  <div
                    id="company-details-collapse"
                    className="company-details-collapse-info"
                  >
                    <ul className="d-flex flex-column align-items-start gap-2 list-unstyled mb-0">
                      <li className="fs-14 text-gray-700 d-flex align-items-center gap-2">
                        <Image
                          className="company-details-collapse-btn-arrow"
                          src="/images/envelope-blue.svg"
                          width={18}
                          height={18}
                          alt="Envelope Icon"
                        />
                        <span>{showCompany?.email}</span>
                      </li>
                      {showCompany?.phoneNo && (
                        <li className="fs-14 text-gray-700 d-flex align-items-center gap-2">
                          <Image
                            className="company-details-collapse-btn-arrow"
                            src="/images/phone-call-blue.svg"
                            width={18}
                            height={18}
                            alt="Phone Icon"
                          />
                          <span>
                            +{showCompany?.countryCode} {showCompany?.phoneNo}
                          </span>
                        </li>
                      )}
                      <li className="fs-14 text-gray-700 d-flex align-items-center gap-2">
                        <Image
                          className="company-details-collapse-btn-arrow"
                          src="/images/map-pin-blue.svg"
                          width={18}
                          height={18}
                          alt="Map Pin Icon"
                        />
                        <span>{getAddress(showCompany)}</span>
                      </li>
                    </ul>
                  </div>
                </Collapse>
              </div>

              <input
                type="text"
                className="form-control form-control-search bg-gray-100 border-0 chat-search"
                onChange={(event) =>
                  changeCompanyFilterCriteriaByName(
                    "search",
                    event.target.value,
                  )
                }
                placeholder="Search here..."
              />

              {companyExpertise &&
                Object.keys(companyExpertise)?.map((element, row) => (
                  <>
                    <h3 key={row} className={`fs-16 fw-bold px-2 mb-2 mt-2`}>
                      {element}
                    </h3>
                    {companyExpertise[element].map((subElem, index) => {
                      const isLast =
                        index === companyExpertise[element].length - 1;
                      if (subElem?.children?.length == 0) {
                        return (
                          <div
                            key={subElem?.id}
                            className="chat-contact chat-contact-radio d-flex align-items-center flex-row-reverse justify-content-between gap-3"
                          >
                            <input
                              type="radio"
                              name="recent"
                              id={subElem?.id}
                              checked={subElem?.id === callRequest.expertiseId}
                              value={subElem?.id}
                              onChange={() =>
                                createCallRequest(subElem?.id, true)
                              }
                            />
                            <label
                              htmlFor={subElem?.id}
                              className={`chat-contact-label w-100 d-flex align-items-center justify-content-between ${isLast ? "" : "border-bottom"} border-grey-200 px-2 py-3 gap-3`}
                            >
                              <div className="d-flex align-items-center gap-3">
                                <ImagePreviewLightbox
                                  className="user-avtar user-avtar-48"
                                  src={
                                    Array.isArray(subElem?.images)
                                      ? subElem.images[0] ||
                                        "/images/user-circle.svg"
                                      : subElem?.images ||
                                        "/images/user-circle.svg"
                                  }
                                >
                                  <Image
                                    className="rounded-pill"
                                    src={
                                      Array.isArray(subElem?.images)
                                        ? subElem.images[0] ||
                                          "/images/user-circle.svg"
                                        : subElem?.images ||
                                          "/images/user-circle.svg"
                                    }
                                    width={48}
                                    height={48}
                                    alt="User Icon"
                                  />
                                </ImagePreviewLightbox>
                                <p className="fs-16 fw-semibold text-gray-700 mb-0">
                                  {subElem?.fullName}
                                </p>
                              </div>
                            </label>
                          </div>
                        );
                      } else if (subElem?.children?.length > 0) {
                        return (
                          <>
                            <Button
                              variant=""
                              className="product-collapse-btn d-flex align-items-center justify-content-between gap-4"
                              onClick={() =>
                                toggleCollapse(subElem.id || index)
                              }
                              aria-controls={`product-collapse-${subElem.id || index}`}
                              aria-expanded={
                                !!productCollapse[subElem.id || index]
                              }
                            >
                              <div className="d-flex align-items-center gap-3">
                                <div className="product-icon">
                                  <ImagePreviewLightbox
                                    className="user-avtar user-avtar-48"
                                    src={
                                      Array.isArray(subElem?.images)
                                        ? subElem.images[0] ||
                                          "/images/user-circle.svg"
                                        : subElem?.images ||
                                          "/images/user-circle.svg"
                                    }
                                  >
                                    <Image
                                      className="rounded-pill"
                                      src={
                                        Array.isArray(subElem?.images)
                                          ? subElem.images[0] ||
                                            "/images/user-circle.svg"
                                          : subElem?.images ||
                                            "/images/user-circle.svg"
                                      }
                                      width={48}
                                      height={48}
                                      alt="User Icon"
                                    />
                                  </ImagePreviewLightbox>
                                </div>
                                <p className="fs-16 fw-semibold text-gray-700 mb-0">
                                  {subElem?.fullName}
                                </p>
                              </div>
                              <Image
                                className="product-collapse-btn-arrow"
                                src="/images/caret-up.svg"
                                width={24}
                                height={24}
                                alt="Caret Up Icon"
                              />
                            </Button>
                            <Collapse
                              in={!!productCollapse[subElem.id || index]}
                            >
                              <div
                                id={`product-collapse-${subElem.id || index}`}
                                className="product-list-collapse"
                              >
                                {subElem?.children.map((subProd, subProdId) => (
                                  <div className="chat-contact chat-contact-radio d-flex align-items-center flex-row-reverse justify-content-between gap-3">
                                    <input
                                      type="radio"
                                      name="recent"
                                      id={subProd?.name}
                                      checked={
                                        subProd?.id === callRequest.expertiseId
                                      }
                                      onChange={() =>
                                        createCallRequest(subProd?.id, true)
                                      }
                                    />
                                    <label
                                      htmlFor={subProd?.name}
                                      className="chat-contact-label w-100 d-flex align-items-center justify-content-between p-3 gap-3"
                                    >
                                      <div className="d-flex align-items-center gap-2">
                                        <ImagePreviewLightbox
                                          className="user-avtar user-avtar-36"
                                          src={
                                            Array.isArray(subProd?.images)
                                              ? subProd?.images[0] ||
                                                "/images/product-icon.png"
                                              : subProd?.images ||
                                                "/images/product-icon.png"
                                          }
                                        >
                                          <Image
                                            className="rounded-pill"
                                            src={
                                              Array.isArray(subProd?.images)
                                                ? subProd?.images[0] ||
                                                  "/images/product-icon.png"
                                                : subProd?.images ||
                                                  "/images/product-icon.png"
                                            }
                                            width={36}
                                            height={36}
                                            alt="User Icon"
                                          />
                                        </ImagePreviewLightbox>
                                        <p className="fs-16 fw-semibold text-gray-700 mb-0">
                                          {subProd?.name}
                                        </p>
                                      </div>
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </Collapse>
                          </>
                        );
                      }
                    })}
                  </>
                ))}
            </>
          )}

          {tab == 1 && (
            <div className="chat-filters p-0">
              <input
                type="text"
                onChange={(event) =>
                  changeFilterCriteriaByName("search", event.target.value)
                }
                className="form-control form-control-search bg-gray-100 border-0 chat-search"
                placeholder="Search here..."
              />
              <div className="chat-filter-tabs">
                <button
                  type="button"
                  onClick={() =>
                    changeFilterCriteriaByName("userTypeFilter", "0")
                  }
                  className={`chat-filter ${filter.userTypeFilter == 0 ? "active" : ""}`}
                >
                  All
                </button>
                <button
                  type="button"
                  className={`chat-filter ${filter.userTypeFilter == 1 ? "active" : ""}`}
                  onClick={() =>
                    changeFilterCriteriaByName("userTypeFilter", "1")
                  }
                >
                  Internal
                </button>
                <button
                  type="button"
                  className={`chat-filter ${filter.userTypeFilter == 2 ? "active" : ""}`}
                  onClick={() =>
                    changeFilterCriteriaByName("userTypeFilter", "2")
                  }
                >
                  External
                </button>
              </div>
            </div>
          )}

          {tab == 1 && (
            <div className="chat-contact-list mt-3">
              <div className="mb-4">
                {supportList &&
                  Object.keys(supportList)?.map((element, row) => (
                    <>
                      <h3
                        key={row}
                        className={`fs-16 fw-bold px-2 ${row == 0 ? "mb-2" : "mb-2 mt-2"}`}
                      >
                        {element}
                      </h3>
                      {supportList[element].map((subElem, index) => {
                        const isLast =
                          index === supportList[element].length - 1;
                        if (subElem?.roleId == 3) {
                          return (
                            <div
                              key={subElem?.id}
                              className="chat-contact chat-contact-radio d-flex align-items-center flex-row-reverse justify-content-between gap-3"
                            >
                              <input
                                type="radio"
                                name="recent"
                                id={subElem?.id}
                                checked={subElem?.id === callRequest.userId}
                                onChange={() =>
                                  createCallRequest(subElem?.id, false)
                                }
                              />
                              <label
                                htmlFor={subElem?.id}
                                className={`chat-contact-label w-100 d-flex align-items-center justify-content-between ${isLast ? "" : "border-bottom"} border-grey-200 px-2 py-3 gap-3`}
                              >
                                <div className="d-flex align-items-center gap-3">
                                  <ImagePreviewLightbox
                                    className="user-avtar user-avtar-48"
                                    src={
                                      subElem?.profilePic ||
                                      "/images/user-circle.svg"
                                    }
                                  >
                                    <Image
                                      className="rounded-pill"
                                      src={
                                        subElem?.profilePic ||
                                        "/images/user-circle.svg"
                                      }
                                      width={48}
                                      height={48}
                                      alt="User Icon"
                                    />
                                  </ImagePreviewLightbox>
                                  <p className="fs-16 fw-semibold text-gray-700 mb-0">
                                    {subElem?.fullName}
                                  </p>
                                </div>
                              </label>
                            </div>
                          );
                        } else if (subElem?.roleId == 5) {
                          return (
                            <div
                              key={subElem?.id}
                              className="chat-contact chat-contact-radio d-flex align-items-center flex-row-reverse justify-content-between gap-3"
                            >
                              <input
                                type="radio"
                                name="recent"
                                id={subElem?.id}
                                checked={subElem?.id === callRequest.userId}
                                onChange={() =>
                                  createCallRequest(subElem?.id, false)
                                }
                              />
                              <label
                                htmlFor={subElem?.id}
                                className={`chat-contact-label w-100 d-flex align-items-center justify-content-between ${isLast ? "" : "border-bottom"} border-grey-200 px-2 py-3 gap-3`}
                              >
                                <div className="d-flex align-items-center gap-3">
                                  <Image
                                    className="rounded-pill"
                                    src={
                                      subElem?.profilePic ||
                                      "/images/user-circle.svg"
                                    }
                                    // src="/images/user-avatar-1.png"
                                    width={48}
                                    height={48}
                                    alt="User Icon"
                                  />
                                  <p className="fs-16 fw-semibold text-gray-700 mb-0">
                                    {subElem?.fullName}
                                  </p>
                                </div>
                              </label>
                            </div>
                          );
                        } else if (subElem?.roleId == 2) {
                          // const timeData = getCompanyStatus(subElem?.companyHours)
                          return (
                            <div
                              key={subElem?.id}
                              className="chat-contact d-flex align-items-center justify-content-between px-2 py-3 gap-3"
                              onClick={() => getCompanyDetails(subElem)}
                            >
                              <div className="d-flex align-items-center gap-3">
                                <Image
                                  className="rounded-pill"
                                  src={
                                    subElem?.profilePic ||
                                    "/images/company-icon.png"
                                  }
                                  width={48}
                                  height={48}
                                  alt="User Icon"
                                />
                                <div className="d-flex flex-column align-items-start gap-1">
                                  <p className="fs-16 fw-semibold text-gray-700 mb-0">
                                    {subElem?.fullName}
                                  </p>
                                  <ul className="d-flex align-items-center gap-2 list-unstyled mb-0">
                                    {(() => {
                                      const timeData = getCompanyStatus(
                                        subElem?.companyHours,
                                      );
                                      return (
                                        <>
                                          <li
                                            className={`fs-14 fw-medium ${timeData.status === "Closed" ? "text-red-600" : "text-blue-600"}`}
                                          >
                                            {timeData.status}
                                          </li>
                                          <li className="dot-separator"></li>
                                          <li className="fs-14 fw-normal text-gray-500">
                                            {timeData.time}
                                          </li>
                                        </>
                                      );
                                    })()}
                                  </ul>
                                </div>
                              </div>
                              <Image
                                className="opacity-75"
                                src="/images/caret-right.svg"
                                width={20}
                                height={20}
                                alt="Arrow Right"
                              />
                            </div>
                          );
                        }
                      })}
                    </>
                  ))}
              </div>
            </div>
          )}

          {tab == 3 && (
            <>
              <Form.Group
                controlId="request-date"
                className="position-relative mb-3"
              >
                <Form.Label>Request Date</Form.Label>
                <div className="form-control-date">
                  <Form.Control
                    type="date"
                    name="request-date"
                    value={requestDate}
                    onChange={(e) => setRequestDate(e.target.value)}
                    min={new Date().toISOString().split("T")[0]}
                    className={`${formErrors.requestDate ? "is-invalid" : ""}`}
                  />
                  {formErrors.requestDate && (
                    <div className="invalid-feedback">
                      {formErrors.requestDate}
                    </div>
                  )}
                </div>
              </Form.Group>
              {/* START TIME */}
              <Form.Group
                controlId="start-time"
                className="position-relative mb-3"
              >
                <Form.Label>Start Time</Form.Label>
                <Form.Select
                  name="start-time"
                  value={startTime}
                  onChange={(e) => setStartTime(e.target.value)}
                  className={`form-control-time ${formErrors.startTime ? "is-invalid" : ""}`}
                >
                  {timeOptions.map(({ value, label }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </Form.Select>
                {formErrors.startTime && (
                  <div className="invalid-feedback">{formErrors.startTime}</div>
                )}
              </Form.Group>
              {/* END TIME  */}
              <Form.Group
                controlId="end-time"
                className="position-relative mb-3"
              >
                <Form.Label>End Time</Form.Label>
                <Form.Select
                  name="end-time"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                  className={`form-control-time ${formErrors.endTime ? "is-invalid" : ""}`}
                >
                  {timeOptions.map(({ value, label }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </Form.Select>
                {formErrors.endTime && (
                  <div className="invalid-feedback">{formErrors.endTime}</div>
                )}
              </Form.Group>
            </>
          )}
        </Offcanvas.Body>
        <div className="offcanvas-footer">
          {/* TAB 1 — All users & companies */}
          {tab === 1 && (
            <>
              <Button
                variant="primary"
                className="btn-md"
                disabled={callRequest.userId == null}
                onClick={() => {
                  if (callRequest.userId != null) {
                    setTab(3);
                  }
                }}
              >
                Next
              </Button>

              <Button
                variant="outline-secondary"
                className="btn-md"
                onClick={() => {
                  resetSidebar();
                }}
              >
                Cancel
              </Button>
            </>
          )}

          {/* TAB 2 — Company expertise list */}
          {tab === 2 && (
            <>
              <Button
                variant="outline-secondary"
                className="btn-md"
                onClick={() => {
                  setShowCompany(null);
                  setCompanyExpertise(null);
                  setTab(1);
                }}
              >
                Previous
              </Button>

              <Button
                variant="primary"
                className="btn-md"
                disabled={!callRequest.expertiseId}
                onClick={() => {
                  if (callRequest.expertiseId) {
                    setTab(3);
                  }
                }}
              >
                Next
              </Button>
            </>
          )}

          {/* TAB 3 — Schedule form */}
          {tab === 3 && (
            <>
              <Button
                variant="outline-secondary"
                className="btn-md"
                onClick={() => {
                  if (callRequest.userId != null) {
                    setTab(1);
                  } else if (callRequest.adminId && callRequest.expertiseId) {
                    setTab(2);
                  }
                }}
              >
                Previous
              </Button>
              <Button
                variant="primary"
                className="btn-md"
                onClick={() => createCall()}
                disabled={loading}
              >
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Send Request"
                )}
              </Button>
            </>
          )}
        </div>
      </Offcanvas>

      {/* <Modal
        className="info-modal"
        show={modalShow}
        onHide={() => setModalShow(false)}
        centered
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/check-badge-green.svg" alt="Check Icon" />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Video Request Successful!
            </h2>
            <p className="fs-5 text-gray-500 fw-normal mb-0">
              Check your calendar for updates. Notifications will also be sent
              via push and email.
            </p>
            <Button
              className="btn bntn-primary w-100 mt-5"
              onClick={() => setModalShow(false)}
            >
              That’s Great!
            </Button>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  );
};
export default ScheduleSidebar;